module.exports = __webpack_public_path__ + "img/Android3.55db4dcc.png";